import React from 'react';
import { logo } from 'assets/images';
import { Link } from 'react-router-dom';
import {
  LinkButton,
  EmailButton,
  LocationButton,
} from 'components/widgets/Buttons';
import { facebook, instagram, linkedin, twitter, youtube } from 'assets/icons';

function PageFooter() {
  return (
    <>
      <div className="text-black grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 mx-10 md:mx-20">
        <div>
          <Link to="/" className="shrink-0 grow-0 rounded-full">
            <img src={logo} width={40} height={40} alt="restaurant logo" />
          </Link>
          <p className="pt-6 text-base font-medium">Ashley's Kitchen</p>
          <p className="pt-2 text-sm font-medium">
            For those who don’t have time to cook, <br />
            we’ve got you covered.
          </p>
          <div>
            <p className="text-black font-medium pt-4 text-sm">
              {`© Copyright ${new Date().getFullYear()} Pauline Ondiek All rights reserved.`}
            </p>
          </div>
        </div>
        <div>
          <h3 className="font-semibold text-lg mt-5 mb-2 text-black">
            Navigate
          </h3>
          <div className="grid gap-2 grid-cols-2 mt-6 text-sm">
            <div className="flex flex-col gap-y-2">
              <LinkButton to="/" className="font-medium">
                Home
              </LinkButton>
              <LinkButton to="/Food" className="font-medium">
                Foods
              </LinkButton>
              <LinkButton to="/Drink" className="font-medium">
                Drinks
              </LinkButton>
            </div>

            <div className="flex flex-col gap-y-2">
              <LinkButton to="/Fruits" className="font-medium">
                Fruits
              </LinkButton>
              <LinkButton to="/Dessert" className="font-medium">
                Desserts
              </LinkButton>
              <LinkButton to="/Cart" className="font-medium">
                Cart
              </LinkButton>
            </div>
          </div>
        </div>
        <div>
          <h3 className="font-semibold text-lg mt-5 mb-2 text-black">
            Contact Us
          </h3>
          <div className="text-black flex gap-x-2 font-medium text-sm">
            <LocationButton />
            5040 Ashley's Kitchen, Kenya
          </div>
          <div className="text-black flex gap-x-2 pt-4 font-medium text-sm">
            <EmailButton />
            info@ashley'skitchen.com
          </div>
          <h3 className="font-semibold mt-5 mb-2 text-lg">
            Get In Touch With Us
          </h3>
          <div className="flex gap-x-4">
            <img src={facebook} alt="facebook" width={20} />
            <img src={instagram} alt="instagram" width={20} />
            <img src={linkedin} alt="linkedin" width={20} />
            <img src={twitter} alt="twitter" width={20} />
            <img src={youtube} alt="youtube" width={20} />
          </div>
        </div>
      </div>
    </>
  );
}

export default PageFooter;
